module.exports = __webpack_public_path__ + "img/moonbeam.079027d4.png";